import React from 'react';

const MitosAIFakta: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Survei <b>Kominfo 2024</b> menunjukkan <b>67% masyarakat Indonesia</b> masih percaya mitos keliru tentang kecerdasan buatan. Artikel ini mengupas 5 kesalahpahaman paling umum dan fakta sebenarnya berdasarkan penjelasan pakar.
      </p>

      <h2 className="text-2xl font-bold mb-4">1. Mitos: AI Akan Mengambil Alih Pekerjaan Manusia</h2>
      <p className="mb-2"><b>Fakta:</b></p>
      <ul className="list-disc pl-6 mb-4">
        <li>AI justru menciptakan <b>45 juta pekerjaan baru</b> di Asia Tenggara hingga 2030 (Laporan World Economic Forum)</li>
        <li>Yang berubah adalah <b>jenis pekerjaan</b>, bukan jumlah lapangan kerja</li>
        <li>Contoh nyata: Munculnya profesi <b>AI Trainer</b> dengan gaji Rp12-25 juta/bulan</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">2. Mitos: AI Bisa Berpikir Seperti Manusia</h2>
      <p className="mb-2"><b>Fakta:</b></p>
      <ul className="list-disc pl-6 mb-4">
        <li>AI hanya mengenali <b>pola data</b>, tidak memahami makna sebenarnya</li>
        <li>Sistem seperti ChatGPT tidak memiliki <b>kesadaran atau emosi</b></li>
        <li>Istilah &quot;kecerdasan&quot; pada AI berbeda dengan kecerdasan manusia</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">3. Mitos: Semakin Besar Data, Semakin Pintar AI</h2>
      <p className="mb-2"><b>Fakta:</b></p>
      <ul className="list-disc pl-6 mb-4">
        <li>Kualitas data lebih penting daripada kuantitas</li>
        <li>AI untuk deteksi penyakit di Puskesmas Indonesia hanya menggunakan <b>5.000 data pasien</b> tapi akurasinya 92%</li>
        <li>Data yang tidak relevan justru mengurangi performa sistem</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">4. Mitos: AI Selalu Objektif dan Netral</h2>
      <p className="mb-2"><b>Fakta:</b></p>
      <ul className="list-disc pl-6 mb-4">
        <li>AI bisa mewarisi <b>bias dari data latih</b> dan pembuatnya</li>
        <li>Kasus nyata: Sistem rekrutmen AI di Jakarta semula diskriminatif terhadap lulusan tertentu</li>
        <li>Perlu <b>audit rutin</b> untuk memastikan keadilan algoritma</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">5. Mitos: Hanya Perusahaan Besar yang Butuh AI</h2>
      <p className="mb-2"><b>Fakta:</b></p>
      <ul className="list-disc pl-6 mb-4">
        <li><b>UMKM Indonesia</b> sudah menggunakan AI untuk:
          <ul className="list-disc pl-6 mt-1">
            <li>Prediksi stok (warung kelontong)</li>
            <li>Chatbot pelanggan (home industry)</li>
            <li>Analisis tren pasar (petani)</li>
          </ul>
        </li>
        <li>Tools seperti Canva AI dan Google Business AI bisa digunakan gratis</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">Perspektif Pakar</h2>
      <div className="bg-gray-50 p-4 rounded mb-6">
        <p>
          <i>&quot;Masyarakat tak perlu takut berlebihan atau percaya berlebihan pada AI. Ini hanya alat canggih yang perlu dipahami batasannya&quot;</i> - <b>Dr. Andika Pratama</b>, Peneliti AI Universitas Indonesia.
        </p>
      </div>

      <h2 className="text-2xl font-bold mb-4">3 Langkah Bijak Menyikapi AI</h2>
      <ol className="list-decimal pl-6 mb-6 space-y-2">
        <li><b>Pelajari dasar-dasarnya</b> melalui kursus online gratis</li>
        <li><b>Gunakan secara kritis</b> - selalu verifikasi hasil AI</li>
        <li><b>Ajarkan anak</b> tentang etika berinteraksi dengan teknologi</li>
      </ol>

      <p>
        Untuk informasi lebih lanjut, kunjungi <b>ai-indonesia.id/mitos-fakta</b> atau ikuti workshop gratis dari Kominfo setiap bulan.
      </p>
    </div>
  );
};

export default MitosAIFakta;